/**
 * Make React fire `onChange` for a value that was set on the DOM node imperatively.
 * React skips the input event when its value tracker already holds the current value,
 * so the tracker is set to a different value first and the real value is restored with the native setter.
 *
 * @param node {HTMLInputElement|HTMLTextAreaElement}.
 */
const triggerInputChange = node => {
  const { value } = node;
  const { set: setNativeValue } = Object.getOwnPropertyDescriptor(Object.getPrototypeOf(node), 'value');

  // eslint-disable-next-line no-param-reassign
  node.value = `${value}#`;
  setNativeValue.call(node, value);
  node.dispatchEvent(new Event('input', { bubbles: true }));
};

export default triggerInputChange;
